var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontalLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 12C5.33333 11.7013 5.56799 11.4667 5.86666 11.4667H18.1333C18.4213 11.4667 18.6667 11.7013 18.6667 12C18.6667 12.288 18.4213 12.5333 18.1333 12.5333H5.86666C5.56799 12.5333 5.33333 12.288 5.33333 12Z",
    fill: "#9DA6AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalLineIcon);
export default __webpack_public_path__ + "static/media/horizontal-line-icon.044759cf0f319c9e44305e1513620085.svg";
export { ForwardRef as ReactComponent };